






























import { Component, Prop } from 'vue-property-decorator';
import { AppModule } from '@/store/modules/app';
import { getModule } from 'vuex-module-decorators';
import { Id } from '@/types/Slide';
import Bookmark from '@/models/Bookmark';
import TableOfContentsType from '@/types/TableOfContents';
import { isSubString, isEmpty } from '@/utils/strings';
import { CUSTOM_TERM_FILTER } from '@/constants';
import { mixins } from 'vue-class-component';
import Scorm from '@bob-the-builder/kb4-scorm-client';
import store from '@/store';
import { ThemeConfModule } from '@/store/modules/theme';

const ThemeStore = getModule(ThemeConfModule, store);

@Component
export default class TableOfContents extends mixins(Scorm) {
  @Prop() title!: string;
  search: string = '';
  searchInputValue: string = '';
  AppState = getModule(AppModule, this.$store);

  get toc(): TableOfContentsType {
    return this.AppState.tableOfContents;
  }

  public created() {
    this.init(ThemeStore.getScormOptions);
  }

  get getAlreadyVisitedPages() {
    return this.AppState.alreadyVisitedPagesHash;
  }

  get getCurrentSlide(): Id {
    return this.AppState.getCurrentSlide;
  }

  get isLockedForward(): boolean {
    return this.AppState.isLockedForward;
  }

  get isTotallyLocked(): boolean {
    return this.AppState.isTotallyLocked;
  }

  get filteredList() {
    return this.toc.slides.filter(item => this.isTocSearched(item.title));
  }

  getTitle(title: string): string {
    if (title.indexOf(CUSTOM_TERM_FILTER) > -1) {
      // Has a custom term
      let filteredTitle = title
        .split(`' ${CUSTOM_TERM_FILTER}`)[0]
        .substring(1);
      return (this as any).$options.filters.customTerm(filteredTitle);
    }
    return title;
  }

  private isDisabled(id: string, index: number): boolean {
    if (this.isTocActive(id)) return false;
    if (this.isLockedForward && index > this.AppState.getCurrentIndex)
      return true;
    return !this.getAlreadyVisitedPages[id] || this.isTotallyLocked;
  }

  private setSlide(id: Id, index: number) {
    if (this.isDisabled(id, index) || id == this.getCurrentSlide) return;
    this.AppState.goTo([id, index]);
    const bookmark = this.getBookmark();

    this.setBookmark(
      new Bookmark(
        this.AppState.currentIndex,
        this.AppState.getCurrentSlideUid,
        this.AppState.getScore,
        this.AppState.getTotalScore,
        this.AppState.getBiggestIndex,
        bookmark.version,
        bookmark.lastSlideState,
        bookmark.testout
      )
    );
  }

  private isTocActive(id: string): boolean {
    const currentSlide = this.$route?.query?.slide || this.getCurrentSlide;
    return id == currentSlide;
  }

  private isTocSearched(searchText: string): boolean {
    if (isEmpty(this.search)) return true;
    return isSubString(searchText, this.search);
  }

  public submit() {
    this.search = this.searchInputValue;
  }
  public reset() {
    this.search = '';
    this.searchInputValue = '';
  }
}
